import React, { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import { toast } from "react-toastify";
import Modal from 'react-bootstrap/Modal';
import { useHistory } from "react-router-dom";
import { Icon } from "@fluentui/react";
import { useAxios } from "../../context/AxiosContext";
import HashtagSuggestions from "./Hashtags";

const ActivityHashtags = ({
  mode, // "edit" or "view"
  artifactId,
  artifactTypeId,
  activityGeneralUpdatedDetails,
  setActivityGeneralUpdatedDetails,
  setActivityGeneralDetails,
  hashtags,
  sethashtags,
  pageType,
  Type,
  template,
  complexityTag,
  enableeditbydefault,
  expand,
  count,
  content
}) => {
  const history = useHistory();
  const { axiosGetService, axiosPostService } = useAxios();

  const [showHashtagsForm, setShowHashtagsForm] = useState(false);
  const [showHashtagsFormtemplate, setShowHashtagsFormtemplate] = useState(false);
  const [hashtagsInput, setHashtagsInput] = useState("");
  const [hashtagSuggestions, setHashtagSuggestions] = useState([]);
  const [hashtagSuggestionInput, setHashtagSuggestionInput] = useState("");
  const [userAddedHashtags, setUserAddedHashtags] = useState([]);
  const [existingHashtags, setExistingHashtags] = useState([]);

  useEffect(() => {
    if (artifactId && artifactTypeId) {
      fetchExistingHashtags();
    }
  }, [artifactId, artifactTypeId]);

  const submitHashtags = async () => {
    if (userAddedHashtags?.length > 0 && mode === "view") {
      const uniqueNewHashtags = userAddedHashtags?.filter(
        (tag) => !existingHashtags?.includes(tag)
      );

      if (uniqueNewHashtags?.length === 0) {
        setHashtagsInput("");
        setUserAddedHashtags([]);
        setHashtagSuggestionInput("");
        return;
      }

      const postData = {
        artifactTypeId,
        artifactId,
        hashtags: [...uniqueNewHashtags, ...existingHashtags]?.toString(),
      };

      try {
        const response = await axiosPostService(`api/sdmhashtags/add`, postData);
        if (response?.data?.status) {
          setExistingHashtags([...uniqueNewHashtags, ...existingHashtags]);
          setHashtagsInput("");
          setUserAddedHashtags([]);
          setHashtagSuggestionInput("");
        } else {
          toast.error(response?.data?.errorMessage, { position: toast.POSITION.TOP_RIGHT });
        }
      } catch (error) {
        toast.error("Error submitting hashtags!", { position: toast.POSITION.TOP_RIGHT });
      }
    }
  };

  const fetchExistingHashtags = async () => {
    try {
      const response = await axiosGetService(
        `api/sdmhashtags/getbyartifact?artifactTypeId=${artifactTypeId}&artifactId=${artifactId}&isDraftId=false`
      );

      if (response?.data?.hashTagsList) {
        setExistingHashtags(response.data.hashTagsList.map((tag) => tag.name));
      } else {
        toast.error(response.data.errorMessage, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      toast.error("Error fetching hashtags!", { position: toast.POSITION.TOP_RIGHT });
    }
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (hashtagSuggestionInput.trim()) {
        hashtagsAutoComplete();
      }
    }, 1000);

    return () => {
      setHashtagSuggestions([]);
      clearTimeout(timeOutId);
    };
  }, [hashtagSuggestionInput]);

  const hashtagsAutoComplete = async () => {
    await axiosGetService(
      `api/sdmhashtags/autocomplete?hashTag=${encodeURIComponent(hashtagSuggestionInput)}`
    ).then((response) => {
      setHashtagSuggestions(response.data);
    });
  };

  const removeHashtag = (tag) => {
    if (pageType === "activity") {
      const updatedHashtags = activityGeneralUpdatedDetails.activityHashTags.filter(
        (item) => tag !== item
      );
      setActivityGeneralUpdatedDetails((prevState) => ({
        ...prevState,
        activityHashTags: updatedHashtags,
      }));
    } else if (pageType === "topics") {
      const updatedHashtags = hashtags.filter((item) => tag !== item);
      sethashtags(updatedHashtags);
    }
  };

  const saveHashtag = () => {
    if (setActivityGeneralDetails) {
      setActivityGeneralDetails((prevState) => ({
        ...prevState,
        activityHashTags: [...activityGeneralUpdatedDetails['activityHashTags']],
      }));
    }
  };

  // UseEffect to call saveHashtag when hashtags are added/updated
  useEffect(() => {
    const activityHashTags = activityGeneralUpdatedDetails?.activityHashTags;
    if (mode === "edit" && activityGeneralUpdatedDetails && activityHashTags?.length > 0) {
      saveHashtag();
    }
  }, [activityGeneralUpdatedDetails, activityGeneralUpdatedDetails?.activityHashTags]);

  const draftHashtags = () => {
    const uniqueNewHashtags = userAddedHashtags?.filter(
      (tag) => !existingHashtags?.includes(tag)
    );

    if (uniqueNewHashtags?.length === 0) {
      setUserAddedHashtags([]);
      setHashtagsInput("");
      return;
    }

    if (mode === "edit" && pageType === "activity") {
      setActivityGeneralUpdatedDetails((prevState) => ({
        ...prevState,
        activityHashTags: [...uniqueNewHashtags, ...activityGeneralUpdatedDetails?.activityHashTags],
      }));
       setExistingHashtags([...uniqueNewHashtags, ...existingHashtags]);
      setUserAddedHashtags([]);
      setShowHashtagsForm(false);
    } else if (mode === "edit" && pageType === "topics") {
      sethashtags([...uniqueNewHashtags, ...hashtags]);
       setExistingHashtags([...uniqueNewHashtags, ...existingHashtags]);
      setUserAddedHashtags([]);
      setShowHashtagsForm(false);
      setHashtagsInput("");
    }
  };

  const closeModal = () => {
    setShowHashtagsFormtemplate(false);
  }

  return (
    <div>
      {(mode === "edit") && (
        <div className={Type === "topicEdit" ? " editHashtag_newdesign_main activityHashtags newActivityEditHashtags" : "activityHashtags newActivityEditHashtags"}>
          <HashtagSuggestions
            className={Type === "topicEdit" ? "editHashtag_newdesign activityEditHashtagsInput" : "activityEditHashtagsInput"}
            enableDropdown={true}
            data={hashtagSuggestions}
            setHashtagSuggestions={setHashtagSuggestions}
            searchValue={hashtagsInput}
            setSearchValue={setHashtagsInput}
            existingHashtags={existingHashtags}
            userAddedHashtags={userAddedHashtags}
            setUserAddedHashtags={setUserAddedHashtags}
            hashtagSuggestionInput={hashtagSuggestionInput}
            setHashtagSuggestionInput={setHashtagSuggestionInput}
            closeHashtagForm={() => {
              setHashtagsInput("");
              setUserAddedHashtags([]);
              setShowHashtagsForm(false);
            }}
            submitHashtags={draftHashtags}
            autoFocus={true}
            showSubmitButton={true}
            pageType={"activityEdit"}
            Type={Type === "topicEdit" ? 'topiceditpage' : ''}
            content={content}
            artifactTypeId={artifactTypeId}
            artifactId={artifactId}
          />

          {mode === "edit" && pageType === "activity" && activityGeneralUpdatedDetails?.activityHashTags?.length > 0 && (
            <div className="hashTagsContaineredit _existingHashTagsOfActivity">
              {activityGeneralUpdatedDetails.activityHashTags.map((item) => (
                <span key={item} tabIndex={0}>
                  {item}{" "}
                  <Icon
                    iconName="Cancel"
                    onClick={() => removeHashtag(item)}
                    tabIndex={0}
                    onKeyPress={(e) => e.which === 13 && removeHashtag(item)}
                    aria-label={`Click to remove ${item} hashtag`}
                    title="Cancel"
                    role="button"
                  />
                </span>
              ))}
            </div>
          )}
          {mode === "edit" && pageType === "topics" && hashtags.length > 0 && (
            <div className="_existingHashTags_Container hashTagsContaineredit _existingHashTagsOfActivity">
              {hashtags.map((item) => (
                <span key={item} tabIndex={0}>
                  {item}{" "}
                  <Icon
                    iconName="Cancel"
                    onClick={() => removeHashtag(item)}
                    tabIndex={0}
                    onKeyPress={(e) => e.which === 13 && removeHashtag(item)}
                    aria-label={`Click to remove ${item} hashtag`}
                    title="Cancel"
                    role="button"
                  />
                </span>
              ))}
            </div>
          )}


        </div>
      )}

{mode === "view" && !showHashtagsForm && !enableeditbydefault && (
  <Col className="existingHashTagsOfActivity _existingHashTagsOfActivity px-0">
    {existingHashtags
      ?.slice(0,  Type === "template"? ( expand ? existingHashtags?.length : count) : existingHashtags?.length ) // If expand is true, show all hashtags; otherwise, show the first 'count' or default to 2
      ?.map((name) => (
        <span
          role="link"
          aria-label={name}
          tabIndex={0}
          key={name}
          onClick={() => history.push(`/search?searchParam=${encodeURIComponent(name)}`)}
          onKeyPress={(e) => e.which === 13 && history.push(`/search?searchParam=${encodeURIComponent(name)}`)}
        >
          {name}
        </span>
      ))}



{!enableeditbydefault && <div className="addHashtagsIconContainer _addHashtagsIconContainer">
            <span
              title="Add Hashtags"
              className="_addHashtagsIcon"
              onClick={() => {
                if (Type === "template") {
                  setShowHashtagsFormtemplate(true);
                }
                else {
                  setShowHashtagsForm(true);

                }
              }}
              onKeyPress={(e) => {
                if (e.which === 13) {
                  if (Type === "template") {
                    setShowHashtagsFormtemplate(true);
                  }
                  else {
                    setShowHashtagsForm(true);

                  }
                }
              }}
              tabIndex="0"
              role="button"
              aria-label="Add Hashtags"
            ></span>

          </div>}
        </Col>
      )}


      {((mode === "view" && showHashtagsForm) || enableeditbydefault) && (
        <div className="activityHashtags newActivityEditHashtags">
          <HashtagSuggestions
            className="activityEditHashtagsInput"
            enableDropdown={true}
            data={hashtagSuggestions}
            setHashtagSuggestions={setHashtagSuggestions}
            searchValue={hashtagsInput}
            setSearchValue={setHashtagsInput}
            existingHashtags={existingHashtags}
            userAddedHashtags={userAddedHashtags}
            setUserAddedHashtags={setUserAddedHashtags}
            hashtagSuggestionInput={hashtagSuggestionInput}
            setHashtagSuggestionInput={setHashtagSuggestionInput}
            closeHashtagForm={() => {
              setHashtagsInput("");
              setUserAddedHashtags([]);
              setShowHashtagsForm(false);
            }}
            submitHashtags={submitHashtags}
            autoFocus={true}
            showSubmitButton={true}
            pageType={"activityEdit"}
            content={content}
            artifactTypeId={artifactTypeId}
            artifactId={artifactId}
          />

          <Col className="existingHashTagsOfActivity _existingHashTagsOfActivity _existingHashTags_Container px-0">
            {existingHashtags.map((name) => (
              <span
                role="link"
                aria-label={name}
                tabIndex={0}
                key={name}
                onClick={() => history.push(`/search?searchParam=${encodeURIComponent(name)}`)}
                onKeyPress={(e) => e.which === 13 && history.push(`/search?searchParam=${encodeURIComponent(name)}`)}
              >
                {name}
              </span>
            ))}</Col>
        </div>
      )}

      {mode === "view" && showHashtagsFormtemplate && Type === "template" && (

        <Modal
          show={showHashtagsFormtemplate}
          onHide={closeModal}
          centered
          dialogClassName="hashTagstemplateModal"
        >
          {showHashtagsFormtemplate ? (
            <>
              <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                  Add Hashtags
                </Modal.Title>
                <Icon
                  iconName="Cancel"
                  tabIndex={0}
                  onKeyPress={(e) => {
                    if (e.which === 13) {
                      closeModal();
                    }
                  }}
                  onClick={() => {
                    closeModal();
                  }}
                  role="button"
                  aria-label="Close Add Hashtags"
                />
              </Modal.Header>
              <Modal.Body>
                <div className="hashtagsOfTemplateContainer">
                  <div className="detailsOfHashtagsTemplate">
                    <p>
                      <span className="bold">Template:&nbsp; </span>
                      <span>{template.title}</span>
                    </p>
                    <p>
                      <span className="bold">Phase Name:&nbsp; </span>
                      <span>{template.phaseName}</span>
                    </p>
                    <p>
                      <span className="bold">Complexity:&nbsp; </span>
                      <span>{complexityTag.name}</span>
                    </p>
                  </div>
                  <div className="templateDetailsHasttagsContainer">
                    <div className="templatesHasttagsContainer">
                      <span className="bold pb-1">Add #Hashtags</span>
                      <div className="activityHashtags newActivityEditHashtags">
                        <HashtagSuggestions
                          className="activityEditHashtagsInput"
                          enableDropdown={true}
                          data={hashtagSuggestions}
                          setHashtagSuggestions={setHashtagSuggestions}
                          searchValue={hashtagsInput}
                          setSearchValue={setHashtagsInput}
                          existingHashtags={existingHashtags}
                          userAddedHashtags={userAddedHashtags}
                          setUserAddedHashtags={setUserAddedHashtags}
                          hashtagSuggestionInput={hashtagSuggestionInput}
                          setHashtagSuggestionInput={setHashtagSuggestionInput}
                          closeHashtagForm={() => {
                            setHashtagsInput("");
                            setUserAddedHashtags([]);
                            setShowHashtagsForm(false);
                          }}
                          submitHashtags={submitHashtags}
                          autoFocus={true}
                          showSubmitButton={true}
                          pageType={"activityEdit"}
                          content={content}
                          artifactTypeId={artifactTypeId}
            artifactId={artifactId}
                        />

                        <Col className="existingHashTagsOfActivity _existingHashTagsOfActivity _existingHashTags_Container px-0">
                          {existingHashtags.map((name) => (
                            <span
                              role="link"
                              aria-label={name}
                              tabIndex={0}
                              key={name}
                              onClick={() => history.push(`/search?searchParam=${encodeURIComponent(name)}`)}
                              onKeyPress={(e) => e.which === 13 && history.push(`/search?searchParam=${encodeURIComponent(name)}`)}
                            >
                              {name}
                            </span>
                          ))}</Col>
                      </div>

                    </div>
                  </div>
                  <div className="templatesDetailsHasttagButtons">
                    <button
                      onClick={() => {
                        closeModal();
                      }}
                      aria-label="Close"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Modal.Body>
            </>
          ) : (
            <></>
          )}
        </Modal>
      )}
    </div>
  );
};

export default ActivityHashtags;
